import { render, staticRenderFns } from "./star_assignment_zen_page.vue?vue&type=template&id=08ea5ea6&scoped=true"
import script from "./star_assignment_zen_page.vue?vue&type=script&lang=js"
export * from "./star_assignment_zen_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea5ea6",
  null
  
)

export default component.exports